__webpack_require__.p = "https://upptic-dev-dashboard.s3.us-east-2.amazonaws.com/framework/v2.8.0-alpha.1-dev/";